import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { cluerApplyecord } from '@/api/gucangSales/clueManage'
import { useRoute } from 'vue-router'

const __default__ = {
  name: 'TabsOperationLog'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  returnName: {
    type: String
  },
  title: String
},
  setup(__props) {

const route = useRoute()
const props = __props
const fetch = (params: object, callBack: (res: any) => void) => {
  if (route.query.recordId) {
    cluerApplyecord({
      recordId: route.query.recordId
    }).then((res) => {
      // 处理数据
      const state: any = {
        1: '待审批',
        2: '已通过',
        3: '已驳回'
      }
      const result = []
      result.push({
        checkTime: res.data.applyTime,
        checkUser: res.data.createByName,
        checkNode: '申请',
        content: `申请原因：${res.data.applyReason}`
      })
      // 审批
      result.push({
        checkTime: res.data.auditTime,
        checkUser: res.data.auditorName,
        checkNode: '审批',
        content: state[res.data.auditStatus] + `${res.data.opinion ? '【' + res.data.opinion + '】' : ''}`
      })
      // 拼申请人
      callBack({
        data: result
      })
    })
  }
}
const columns = ref([
  {
    title: '操作时间',
    dataIndex: 'checkTime'
  },
  {
    title: '操作人',
    dataIndex: 'checkUser'
  },
  {
    title: '节点',
    dataIndex: 'checkNode'
  },
  {
    title: '内容',
    dataIndex: 'content'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, { scrollToFirstError: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_card, {
        title: props.title,
        span: 24
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_cos_table, {
                tableId: "DcCosFbuApplyRecord",
                needPage: false,
                serial: "",
                columns: columns.value,
                onFetch: fetch,
                ref: "table"
              }, null, 8, ["columns"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}
}

})